export default {
      id: "navigation-background-usage",
      viewBox: "0 0 274 390",
      url: "../../assets/" + "sprite.svg#navigation-background-usage",
      toString: function () {
        return this.url;
      }
    }